import callApi from "Common/utils/apiCaller";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Drawer from "../Drawer";
import ImageView from "../ImageView/ImageView";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import {
  Download,
  Plus,
  Search,
  SlidersHorizontal,
  X,
  Rows4,
  GridIcon,
} from "lucide-react";
import _ from "lodash";
import { getImageUrl } from "Common/utils/ImageDomain";
import { showNotification } from "Common/utils/Notification";
import ImageData from "../customImage/ImageSegment";
import Button from "../ButtonComponent/Button";
import DynamicLink from "../DynamicLink/DynamicLink";
import CustomInput from "../InputFields/CustomInput";
import Modal from "../Modal";
import BlogBannerSegmentCard from "../BlogBannerSegmentCard";

const BannerSegmentTwo = ({
  pageType,
  pageId,
  data,
  handleDelete,
  loader,
  setLoader,
  isEditable,
  versionData,
  segmentId,
  toggleVisiblity,
  segmentType = null,
}) => {
  const [buttons, setButtons] = useState(data?.buttons ? data?.buttons : []);
  const [index, setIndex] = useState<any>(undefined);
  const [imageUrl, setImageUrl] = useState(data?.banner_image_url);
  const [headerText, setHeaderText] = useState(data?.banner_header_text);
  const [eventData, setEventData] = useState<any>();
  const [showVideo, setShowVideo] = useState(false);
  const [subHeaderText, setSubHeaderText] = useState(
    data?.banner_sub_header_text
  );
  const [imageId, setImageId] = useState(data?.banner_image_media_id);
  const [isLoading, setIsLoading] = useState<any>(false);
  const [showLink, setShowLink] = useState<any>(false);
  const [dynamicLink, setDynamicLink] = useState<any>("");
  const toggleLink = () => setShowLink(!showLink);

  const [errors, setErrors] = useState<any>({
    banner_image_url: "",
    banner_header_text: "",

    buttons: buttons?.map(() => ({ label: "", value: "" })),
  });
  useEffect(() => {
    if (dynamicLink && dynamicLink !== "") {
      if (index) {
        handleInputChange(index - 1, "value", dynamicLink);
      }
    }
  }, [dynamicLink, index]);
  const toggle = () => setShowVideo(!showVideo);
  useEffect(() => {
    if (eventData && eventData.media_url) {
      setImageUrl(eventData?.media_url);
      setImageId(eventData?._id);
      setErrors((prev) => ({
        ...prev,
        ["banner_image_url"]: "",
      }));
    }
  }, [eventData]);

  const handleRemoveBanner = async (pageId, id) => {
    try {
      const res = await callApi(
        `v1/${pageType}/${pageId}/banner-segment/${id}/remove-segment`,
        "post",
        {}
      );
      if (res.status === "Success") {
        showNotification("Segment removed successfully", "success");
        setLoader(!loader);
      }
    } catch (e) {
      showNotification("Error occured", "error");
    }
  };
  const addButton = () => {
    setButtons([...buttons, { label: "", value: "" }]);
    let newErrors = { ...errors };
    newErrors.buttons.push({ label: "", value: "" });
    setErrors(newErrors);
  };
  const removeButton = (index) => {
    const updatedButtons = buttons.filter((_, i) => i !== index);
    setButtons(updatedButtons);
    const updatedErrors = { ...errors };
    updatedErrors.buttons.splice(index, 1);
    setErrors(updatedErrors);
  };

  const handleInputChange = (index, field, value) => {
    const updatedButtons = buttons.map((button, i) => {
      if (i === index) {
        button[field] = value;
      }
      return button;
    });
    setButtons(updatedButtons);

    const updatedErrors = { ...errors };
    if (updatedErrors.buttons[index]) {
      updatedErrors.buttons[index][field] = "";
    }
    setErrors(updatedErrors);
  };
  const handleSave = async (pageId, id) => {
    const newErrors = {
      banner_image_url:
        imageUrl.trim() === "" ? "Please enter an image URL." : "",
      banner_header_text:
        // headerText.trim() === "" ? "Please enter a banner header." : "",
        headerText.trim() === "" ? "Please enter banner name." : "",

      buttons: buttons?.map(() => ({ label: "", value: "" })),
    };

    buttons.forEach((button, index) => {
      if (!button.label.trim()) {
        newErrors.buttons[index].label = "label is required .";
      }
      if (!button.value.trim()) {
        newErrors.buttons[index].value = "value is required .";
      }
    });

    setErrors(newErrors);

    if (
      !newErrors.banner_image_url 
      // && !newErrors.banner_header_text &&newErrors?.buttons?.every((error) => !error.label && !error.value)
    ) {
      const payload = {
        segment_type: "banner_segments",
        banner_image_url: imageUrl,
        banner_header_text: headerText,
        banner_sub_header_text: subHeaderText,
        banner_image_media_id: imageId,
        buttons,
      };

      try {
        setIsLoading(true);
        const response = await callApi(
          `v1/${pageType}/${pageId}/segment/${id}/update-info`,
          "post",
          payload
        );
        setIsLoading(false);
        if (response && response?.status === "Success") {
          setLoader(!loader);
          showNotification("Banner added successfully!", "success");
        } else {
          showNotification("Something went wrong. Please try again.", "error");
        }
      } catch (e) {
        showNotification(
          "An error occurred while adding the banner. Please try again.",
          "error"
        );
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <div className="bg-white border border-black-600 rounded-[5px] px-8 py-4">
        {/* Image URL Input */}
        <div className="xl:col-span-12">
          {imageUrl ? (
            <div className="flex items-center">
              <ImageData
                imageLink={imageUrl}
                setImageData={setEventData}
                setImageLink={setImageUrl}
              />
              <div className="h-3 ml-3">
                <button
                  onClick={() => {
                    toggle();
                    setEventData(undefined);
                  }}
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  Change
                </button>
              </div>
            </div>
          ) : (
            <button
              onClick={toggle}
              className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
            >
              Add imageUrl
            </button>
          )}
          {errors.banner_image_url && (
            <p className="text-red-500">{errors.banner_image_url}</p>
          )}
        </div>

        <div className="mt-4 xl:col-span-12">
          <CustomInput
            label=" Banner Header Text"
            name="banner_header_text"
            type="text"
            // value={headerText}
            value={"header text"}
            // placeholder="Enter Header Text"
            placeholder="Enter Banner Header Text"
            disabled
            onChange={(e) => {
              setErrors((prev) => ({
                ...prev,
                ["banner_header_text"]: "",
              }));
              setHeaderText(e.target.value);
            }}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.banner_header_text}
            // error={errors?.banner_header_text}
          />
        </div>

        {/* Banner Sub Header Text Input */}
        <div className="mt-4 xl:col-span-12">
          <CustomInput
            label="Banner Sub Header Text"
            name="banner_sub_header_text"
            type="text"
            disabled
            // value={subHeaderText}
            value={""}
            placeholder="Enter Sub Header Text"
            onChange={(e) => {
              setErrors((prev) => ({
                ...prev,
                ["banner_sub_header_text"]: "",
              }));
              setSubHeaderText(e.target.value);
            }}
            isVersioned={versionData ? true : false}
            versionedValue={versionData?.banner_sub_header_text}
          />
        </div>
        {/* Add Button */}
        {/* <div className="flex justify-end my-4">
          <button
            onClick={addButton}
            className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
          >
            Add Button
          </button>
        </div> */}
        {versionData?.buttons && versionData?.buttons?.length > 0 && (
          <p>Old data</p>
        )}
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {/* Render Buttons */}
          {versionData?.buttons?.map((button, index) => (
            <div key={index} className="py-4 xl:col-span-4">
              <BlogBannerSegmentCard
                index={index}
                button={button}
                toggleLink={toggleLink}
                setIndex={setIndex}
                setDynamicLink={setDynamicLink}
                isEditable={false}
                errors={errors}
                handleInputChange={handleInputChange}
                removeButton={removeButton}
              />
            </div>
          ))}
        </div>
        {buttons?.length > 0 && <p>New data</p>}
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {/* Render Buttons */}
          {buttons?.map((button, index) => (
            <div key={index} className="py-4 xl:col-span-4">
              <BlogBannerSegmentCard
                index={index}
                button={button}
                toggleLink={toggleLink}
                setIndex={setIndex}
                setDynamicLink={setDynamicLink}
                isEditable={true}
                errors={errors}
                handleInputChange={handleInputChange}
                removeButton={removeButton}
              />
            </div>
          ))}
        </div>
        {/* Save Button */}
        <div className="flex justify-end gap-2 mt-4">
          <Button
            isLoading={isLoading}
            handleSave={handleSave}
            pageId={pageId}
            id={segmentId}
          />

          {/* <button
            className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
            onClick={() => handleRemoveBanner(pageId, segmentId)}
          >
            Delete
          </button> */}
        </div>
      </div>
      <Drawer
        show={showVideo}
        onHide={toggle}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Video"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showVideo}
            setEventData={setEventData}
            togleImage={toggle}
          />
        </Drawer.Body>
      </Drawer>
      <Modal
        show={showLink}
        onHide={toggleLink}
        id="defaultModal"
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600 flex flex-col h-full"
      >
        <Modal.Header
          className="flex items-center justify-between p-4 border-b border-slate-200 dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-500 hover:text-red-500 dark:text-zink-200 dark:hover:text-red-500"
        >
          <Modal.Title className="text-16">{"Add Link"}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          {/* <h5 className="mb-3 text-16">{}</h5> */}
          <div className="h-[400px] text-slate-500 dark:text-zink-200">
            <DynamicLink
              showLink={showLink}
              toggleLink={toggleLink}
              setLink={setDynamicLink}
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BannerSegmentTwo;
